import { DataHubActions } from '../../dataHubActions';
import { DataHubEntities } from '../../dataHubEntities';
import { BaseClickSchema } from '../baseClickSchema';
export class ClickContentCheckPageSchema extends BaseClickSchema {
    constructor({ actionType }) {
        super({
            componentName: 'PAGE_CARD_CHECKBOX'
        });
        Object.defineProperty(this, "action", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "entity", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "actionType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.action = DataHubActions.ClickContentCheckPage;
        this.entity = DataHubEntities.Admin;
        this.actionType = actionType;
    }
    getDataHubEventData() {
        return {
            ...super.prepare(),
            actionType: this.actionType
        };
    }
}
